document.addEventListener('alpine:init', () => {
    Alpine.data('signaturePad', (config = {}) => ({
        method: config.initialMethod || (config.allowTyped !== false ? 'type' : 'draw'),
        allowTyped: config.allowTyped !== false,
        allowDrawn: config.allowDrawn !== false,
        typedName: '',
        hasInk: false,
        saved: false,
        isDrawing: false,
        lastPoint: null,
        canvas: null,
        ctx: null,
        dpr: 1,
        width: config.width || 600,
        height: config.height || 200,
        strokeColor: config.strokeColor || '#111',
        lineWidth: config.lineWidth || 2.5,
        typedFont: config.typedFont || 'Caveat',

        init() {
            this.canvas = this.$refs.canvas;
            this.dpr = window.devicePixelRatio || 1;
            this.canvas.width = this.width * this.dpr;
            this.canvas.height = this.height * this.dpr;
            this.canvas.style.width = this.width + 'px';
            this.canvas.style.height = this.height + 'px';
            this.ctx = this.canvas.getContext('2d');
            this.ctx.scale(this.dpr, this.dpr);
            this.resetStroke();
            this.bindPointer();
            this.$watch('method', () => this.onMethodChange());
            this.$watch('typedName', (v) => { if (this.method === 'type') this.renderTyped(v); });

            this.saveHandler = () => this.save();
            this.$el.addEventListener('signature-pad:request-save', this.saveHandler);
            this.windowSaveHandler = (e) => {
                if (!config.listenOnWindow) return;
                this.save();
            };
            if (config.listenOnWindow) {
                window.addEventListener('signature-pad:request-save', this.windowSaveHandler);
            }
        },

        destroy() {
            if (this.saveHandler) {
                this.$el.removeEventListener('signature-pad:request-save', this.saveHandler);
            }
            if (this.windowSaveHandler) {
                window.removeEventListener('signature-pad:request-save', this.windowSaveHandler);
            }
        },

        resetStroke() {
            this.ctx.lineWidth = this.lineWidth;
            this.ctx.lineCap = 'round';
            this.ctx.lineJoin = 'round';
            this.ctx.strokeStyle = this.strokeColor;
        },

        bindPointer() {
            const c = this.canvas;
            c.addEventListener('pointerdown', (e) => {
                if (this.method !== 'draw' || this.saved) return;
                e.preventDefault();
                try { c.setPointerCapture(e.pointerId); } catch (_) {}
                this.isDrawing = true;
                this.lastPoint = this.pos(e);
                this.hasInk = true;
                this.ctx.beginPath();
                this.ctx.moveTo(this.lastPoint.x, this.lastPoint.y);
                this.ctx.lineTo(this.lastPoint.x + 0.01, this.lastPoint.y + 0.01);
                this.ctx.stroke();
            });
            c.addEventListener('pointermove', (e) => {
                if (!this.isDrawing || this.method !== 'draw') return;
                e.preventDefault();
                const p = this.pos(e);
                const pressure = (e.pressure && e.pressure > 0 && e.pressure !== 0.5) ? e.pressure : null;
                this.ctx.lineWidth = pressure ? Math.max(0.75, pressure * 4) : this.lineWidth;
                this.ctx.beginPath();
                this.ctx.moveTo(this.lastPoint.x, this.lastPoint.y);
                this.ctx.lineTo(p.x, p.y);
                this.ctx.stroke();
                this.lastPoint = p;
            });
            const endStroke = () => { this.isDrawing = false; this.lastPoint = null; };
            c.addEventListener('pointerup', endStroke);
            c.addEventListener('pointercancel', endStroke);
            c.addEventListener('pointerleave', () => { if (this.isDrawing) endStroke(); });
        },

        pos(e) {
            const r = this.canvas.getBoundingClientRect();
            return { x: e.clientX - r.left, y: e.clientY - r.top };
        },

        onMethodChange() {
            if (this.saved) return;
            this.clear();
            if (this.method === 'type') this.renderTyped(this.typedName);
        },

        renderTyped(name) {
            if (this.saved) return;
            this.ctx.clearRect(0, 0, this.width, this.height);
            this.resetStroke();
            const trimmed = (name || '').trim();
            if (!trimmed) { this.hasInk = false; return; }
            let size = Math.floor(this.height * 0.55);
            this.ctx.fillStyle = this.strokeColor;
            this.ctx.textBaseline = 'middle';
            this.ctx.font = `${size}px "${this.typedFont}", "Segoe Script", "Brush Script MT", cursive`;
            while (this.ctx.measureText(trimmed).width > (this.width - 20) && size > 14) {
                size -= 2;
                this.ctx.font = `${size}px "${this.typedFont}", "Segoe Script", "Brush Script MT", cursive`;
            }
            const m = this.ctx.measureText(trimmed);
            this.ctx.fillText(trimmed, (this.width - m.width) / 2, this.height / 2);
            this.hasInk = true;
        },

        clear() {
            const wasSaved = this.saved;
            this.saved = false;
            this.ctx.clearRect(0, 0, this.width, this.height);
            this.resetStroke();
            this.hasInk = false;
            this.typedName = '';
            if (wasSaved) {
                this.$dispatch('signature-pad:cleared');
            }
        },

        setMethod(m) { this.method = m; },

        dataUrl() {
            return this.canvas.toDataURL('image/png');
        },

        save() {
            if (this.saved) return;
            if (!this.hasInk) {
                this.$dispatch('signature-pad:empty');
                return;
            }
            this.saved = true;
            this.$dispatch('signature-pad:saved', {
                dataUrl: this.dataUrl(),
                method: this.method,
                typedName: this.method === 'type' ? this.typedName.trim() : null,
            });
        },
    }));
});
